import { PageContext } from 'context/PageContext';
import { useContext, useMemo } from 'react';
import { apiInstance, getBaseProxyUrl } from '../services/Api';

export interface SearchParams {
	params: [
		{
			param: string;
			search_config_lov: Lov[];
		},
	];
}

interface SpdSearchResponse {
	data?: {
		response?: Lov[] | Obj;
	};
}

export interface Template {
	templates: TemplateElement[];
}

export interface TemplateElement {
	fieldID: string;
	mandatory: boolean;
	label: string;
	lov: Lov[];
	value: string;
}

type SearchType = {
	name: string;
	params: SearchParam[];
};

type SearchParam = {
	param_name: string;
	param_value: string;
};

export interface Lov {
	label: string;
	value: string;
	default?: boolean;
}

export interface Obj {
	[key: string]: string | number | boolean | object;
}

type search_config_lov = Lov;

export interface SpdSearchInputField {
	param: string;
	value: string | number | boolean | object;
}

interface UseSpdSearchProps {
	spdSearchType: SpdSearchType;
}

export const useSpdSearch = ({ spdSearchType }: UseSpdSearchProps) => {
	const pageContext = useContext(PageContext);

	// Determine the URL: from spdSearchType or from context fallback
	const url = useMemo(() => {
		const metaAreaContent = pageContext?.metaArea?.items?.[0];

		return (
			spdSearchType.searchConfiguration.url ||
			getBaseProxyUrl(metaAreaContent, metaAreaContent?.content?.quoteSearchConfigurationApiEndpoint?.url) ||
			''
		);
	}, [spdSearchType, pageContext]);

	const doMakeSearch = async (): Promise<Lov[]> => {
		if (!url) {
			console.error('No URL defined for SPD search.');
			return [];
		}
		const method = spdSearchType.searchConfiguration.httpMethod?.toLowerCase?.() || 'get';

		try {
			const res: Template = await apiInstance()[method](url);
			return res.templates[0]?.lov ?? [];
		} catch (error) {
			// TODO: Add modal when error
			console.error('SPD search failed:', error);
			return [];
		}
	};

	const doSearch = async (searchType?: SearchType): Promise<Lov[] | Obj> => {
		if (!url) {
			console.error('No URL defined for SPD search.');
			return [{ label: '', value: '' }];
		}
		const method = spdSearchType.searchConfiguration.httpMethod?.toLowerCase?.() || 'get';

		const responseType = spdSearchType.searchConfiguration.responseType;

		try {
			const res: SpdSearchResponse = await apiInstance()[method](url, searchType);

			if (responseType === 'obj') {
				return res.data?.response;
			}

			return Array.isArray(res.data?.response)
				? res.data.response.map(({ label, value }) => ({ label, value }))
				: [];

			// 				if (!Array.isArray(res.data?.response)) return [];

			// if (responseType === 'obj') {
			// 	return res.data.response as Obj;
			// }

			// return res.data.response.map(({ label, value, default: def }) => ({ label, value, default: def }));
		} catch (error) {
			// TODO: Add modal when error
			console.error('SPD search failed:', error);
			return [];
		}
	};

	return { doSearch, doMakeSearch };
};
